export default Object.freeze({
    DIRECT: 'referral',
    MATCH: 'referrals_pool',
})
